import { render, staticRenderFns } from "./editJurisdiction.vue?vue&type=template&id=08608722"
import script from "./editJurisdiction.vue?vue&type=script&lang=js"
export * from "./editJurisdiction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports